/**
 * Created by A665445 on 03/05/2017.
 */
export class AcademicDocument {
    constructor(
        public id?: number,
        public description?: string,
        public academicDocumentUserBlobId?: number,
        public academicDocumentUserBlobFilename?: string
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/academic-document/academic-document.model.ts